import React from 'react';

import PropTypes from 'prop-types';
import uuid from 'react-uuid';

import Button from 'partial/components/Button';
import { ModalCard } from 'partial/components/Modal';

import { termsAndDefinitions } from '../constants';

function TermsAndConditionModal({ onClose }) {
  return (
    <ModalCard
      size="lg"
      title="DST Terms and Conditions of Services"
      onClose={onClose}
    >
      <div className="flex flex-col space-y-4 p-10">
        <div className="flex flex-col space-y-6 h-96 overflow-y-auto bg-gray-100 py-6 px-3 rounded-lg">
          <ol className="list-decimal list-inside leading-relaxed space-y-6 pr-6">
            <li className="font-semibold text-lg">
              Definition and Interpretation
            </li>
            <ol className="leading-relaxed space-y-4">
              <li className="space-y-4">
                <span className="font-semibold">1.1.</span> In this General
                Terms of Service or any of the Specific Terms, the following
                words and expressions shall have the following meanings:
                <table className="table-auto border-collapse border-2 border-gray-700">
                  <tbody>
                    {termsAndDefinitions.map((item) => (
                      <tr key={`terms-${uuid()}`}>
                        <td className="border-2 border-gray-700 align-top font-semibold p-4">
                          {item?.title}
                        </td>
                        {typeof item?.description === 'function' ? (
                          <td className="border align-top p-4">
                            {item?.description()}
                          </td>
                        ) : (
                          <td className="border-2 border-gray-700 align-top p-4">
                            {item?.description}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </li>
              <li>
                <span className="font-semibold">1.2.</span> The headings or
                titles to the clauses in the General Terms are to facilitate
                reference and shall not be referred to or relied upon in the
                construction of any provision of the General Terms.
              </li>
              <li>
                <span className="font-semibold">1.3.</span> Words denoting the
                masculine gender include where the context so admits the
                feminine and neuter genders and vice versa.
              </li>
              <li>
                <span className="font-semibold">1.4.</span> Words denoting
                natural persons include where the context so admits corporations
                and firms and vice versa.
              </li>
              <li>
                <span className="font-semibold">1.5.</span> Unless the context
                otherwise requires, references to Clauses stipulated herein are
                to be construed as references to the Clauses of the General
                Terms.
              </li>
              <li>
                <span className="font-semibold">1.6.</span> References to a
                statute or statutory provision includes a reference to that
                statute or statutory provision and all statutory instruments or
                orders made pursuant to it, as from time to time amended,
                extended, re-enacted or consolidated.
              </li>
              <li>
                <span className="font-semibold">1.7.</span> Any reference to
                “law” shall be construed so as to include, without limitation,
                any Act, ordinance, statutory or municipal, rule, regulation,
                ruling, decree or order enacted, issued or decreed by the
                Legislative Council of Brunei, the Government of Brunei or any
                bureau, minister, agency, court, regulatory body, authority,
                legislative body or department thereof.
              </li>
              <li>
                <span className="font-semibold">1.8.</span> Where the context so
                requires, the words &quot;hereof&quot;, &quot;herein&quot;,
                &quot;hereto&quot;, &quot;hereunder&quot; wherever used shall
                refer to the Terms as a whole and not to any particular
                provisions only.
              </li>
              <li>
                <span className="font-semibold">1.9.</span> The expression
                “month” shall be calculated to be a period from a specific day
                to and including the day immediately preceding the day
                corresponding to the specific day in the subsequent month or if
                there be no such day in such subsequent month, the last day of
                that month.
              </li>
              <li>
                <span className="font-semibold">1.10.</span> If the Platform or
                any Clauses under the General Terms does not provide for when a
                particular payment is due by the Subscriber, that payment will
                be due within seven (7) days of demand by the Service Provider.
              </li>
            </ol>
            <li className="font-semibold text-lg">Application of Terms</li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">2.1.</span> Upon Activation of
                any Service, the Subscriber is deemed to have read and
                understood the applicable Terms, having accepted and agree to be
                bound by the Terms stipulated herein, and such other applicable
                Terms and conditions which the Service Provider may introduce
                from time to time.
              </li>
              <li>
                <span className="font-semibold">2.2.</span> The General Terms
                shall apply to and primarily govern each and/or all of the
                Services (whenever applied for or provided to the Subscriber) in
                addition to any Specific Terms, except to the extent, if any,
                expressly excluded in the Specific Terms; nevertheless:
                <ol className="leading-relaxed pt-4 space-y-4">
                  <li className="space-y-4">
                    <div>
                      <span className="font-semibold">(a)</span> that in the
                      event of any conflict or inconsistency between any
                      provision of the Specific Terms and the General Terms, the
                      documents shall be construed in the following order of
                      precedence:
                    </div>
                    <ol className="leading-relaxed space-y-2">
                      <li>
                        <span className="font-semibold">(i)</span> any other
                        terms and conditions otherwise agreed between us in
                        writing;
                      </li>
                      <li>
                        <span className="font-semibold">(ii)</span> the
                        applicable Specific Terms; and
                      </li>
                      <li>
                        <span className="font-semibold">(iii)</span> the General
                        Terms.
                      </li>
                    </ol>
                    <div>
                      In the event such construction fails to resolve the
                      conflict or inconsistency, such conflict or inconsistency
                      shall be resolved in a manner most favourable to the
                      Service Provider, to the fullest extent permissible under
                      the applicable law;
                    </div>
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> that all rights
                    conferred on the Service Provider under the General Terms
                    with respect to any matter or event shall be additional to
                    said rights conferred under the Specific Terms or any other
                    agreement with the Subscriber with respect to that matter or
                    event.
                  </li>
                </ol>
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Fees and Charges, Deposit, Interest and Taxes
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">3.1.</span> The Service Provider
                may impose Fees and Charges and the Prescribed Rate and may
                subject to the approval of AITI vary or revise any or all of
                them having always that such variation or revision shall take
                effect from the date of such notice or a date determined by the
                Service Provider.
              </li>
              <li>
                <span className="font-semibold">3.2.</span> The Subscriber shall
                only be charged Fees and Charges in respect of the Services that
                it has applied, subscribed for or has utilised. The Fees and
                Charges in respect of the Services shall be at the amount, rates
                and tariffs prescribed by the Service Provider provided always
                that where approval is required, such amount, rates and/or
                tariffs shall subject to the approval of AITI. All rates and
                tariffs, which includes any relevant charges, are made available
                on the Service Provider&apos;s website (
                <a href="https://www.dst.com.bn/">https://www.dst.com.bn/</a>
                ).
              </li>
              <li>
                <span className="font-semibold">3.3.</span> The Subscriber shall
                promptly pay all Fees and Charges and any other sums which may
                be due or payable to the Service Provider pursuant to the
                subscribed Services. All sums payable shall be in accordance to
                the total amount stated in each Bill/eBill, as the case may be,
                which the Service Provider will make available to the Subscriber
                on a monthly basis and where Services are on a pre-paid basis,
                such Fees and Charges shall be made available and paid prior to
                the utilisation of the particular Service.
              </li>
              <li>
                <span className="font-semibold">3.4.</span> Notwithstanding any
                provisions stipulated under this General Term, Specific Terms,
                Fair Use Policy or the Bill/eBill, the Service Provider may, at
                its discretion, make demands on Fees and Charges at any time,
                for any reason and in any circumstances, which includes, but not
                limited to, the following:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> where the Service
                    is terminated either by the Service Provider or the
                    Subscriber pursuant to the provisions under this General
                    Term;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> where, in the
                    sole opinion of the Service Provider, the Service provided
                    has been abandoned by the Subscriber; or
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> where the usage
                    of the Service by the Subscriber, indicated by the charges
                    incurred, is significantly greater than the
                    Subscriber&apos;s average use or exceeds its credit limit.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">3.5.</span> Subject to Clause
                10.1 and without prejudice to Clause 5, the Service Provider
                may, without liability, suspend, restrict, disconnect or
                terminate the Service if any Fees and Charges or part thereof
                remains unpaid for more than thirty (30) days. Any reconnection
                fee or other charges may be imposed by the Service Provider for
                the reconnection of the Service shall be paid by the Subscriber.
              </li>
              <li>
                <span className="font-semibold">3.6.</span> Unless otherwise
                exempted by the Service Provider, the Subscriber shall always
                deposit with the Service Provider the amount as prescribed under
                the Specific Terms and/or any additional sums as may be
                requested by the Service Provider from time to time should the
                Service Provider deem such sum prescribed is insufficient. The
                Subscriber shall not be at liberty to require the Service
                Provider to utilise any sum deposited with the Service Provider
                as payment of any Fees or Charges due and payable. The Service
                Provider:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> shall be entitled
                    to retain all sums deposited by the Subscriber with the
                    Service Provider for so long as any Service (notwithstanding
                    that it has been suspended) or continues to be provided or
                    made available to the Subscriber; and
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> may, at any time,
                    utilise any or all the sums deposited with the Service
                    Provider to settle any amount due, payable or owed to the
                    Service Provider by the Subscriber provided always that a
                    deposit does not relieve the Subscriber from his obligations
                    to pay nor does it constitute a waiver of the Service
                    Provider&apos;s right to suspend, disconnect, or terminate
                    the Service due to any non-payment of the Subscriber.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">3.7.</span> The Service Provider
                shall be entitled to charge the Subscriber interest on any
                amount due or payable and remain unpaid after the stipulated
                time frame provided in the Bill/eBill at the Prescribed Rate
                calculated and compounded in the manner determined by the
                Service Provider from time to time provided always that the
                Service Provider shall be at liberty to debit any Account with
                respect to such interest.
              </li>
              <li>
                <span className="font-semibold">3.8.</span> The Subscriber shall
                bear and pay all required and relevant Taxes. If the Subscriber
                is required under the laws of Brunei Darussalam or the laws of
                any jurisdiction outside Brunei Darussalam to deduct or withhold
                any sum as Taxes imposed on or in respect of any amount due or
                payable to the Service Provider, the Subscriber shall make such
                deduction or withholding as required and the amount payable to
                the Service Provider shall be increased by any such amount
                necessary to ensure that the Service Provider receives a net
                amount equal to the amount which the Service Provider would have
                received in the absence of any such deduction or withholding.
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Bills/Pre-Paid Fees and Charges
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">4.1.</span> The Bill shall be
                made available to the Subscriber via eBill, email or through a
                hardcopy, whichever applicable.
                <br />
                Notwithstanding Clause 4.1, the Subscriber shall be entitled to
                the hardcopy of the Bill upon request over the counter at any
                Authorised Centres of the Service Provider charged at a fee.
              </li>
              <li>
                <span className="font-semibold">4.2.</span> The Billshall be
                deemed received by the Subscriber once the Bill is generated and
                made available through eBill. The Service Provider shall not be
                required to notify the Subscriber on the availability of such
                eBill. It shall be the sole responsibility of the Subscriber to
                check on the availability of such eBill from time to time.
              </li>
              <li>
                <span className="font-semibold">4.3.</span> The Subscriber
                agrees that:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">4.3.1.</span> He shall be
                    responsible to promptly check and verify the accuracy of
                    each Bill issued and at no later than fourteen (14) days
                    after the service of the Bill (“Issue Date”), pursuant to
                    Clause 4.2 raise and inaccuracy or discrepancy with respect
                    to any amount detail stated therein.
                  </li>
                  <li>
                    <span className="font-semibold">4.3.2.</span> He shall
                    provide the Service Provider with any and all information,
                    documentation and assistance requested by the Service
                    Provider to investigate and authenticate any claim,
                    allegation or issue raised by the Subscriber.
                  </li>
                  <li>
                    <span className="font-semibold">4.3.3.</span> He agrees that
                    each Bill unless disputed per Clause 4.3.1, shall be
                    interpreted by the Service Provider as accurate information
                    on the items, entries, matters and sum due stated therein.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">4.4.</span> The Subscriber shall
                pay the Service Provider the total amount shown or stated as due
                or payable to the Service Provider on that Bill within the
                period prescribed therein or, in the absence of any such period
                being prescribed, within twenty-five (25) days after the date
                that such Bill is deemed to have been received pursuant to
                Clause 4.3 (
                <span className="font-semibold">&quot;Issue Date&quot;</span>).
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">4.4.1.</span> In the event
                    that the Subscriber disputes any amount stated in any Bill
                    and intends to withhold payment of the amount, the
                    Subscriber must give the Service Provider a written notice
                    before the Due Date of the Bill and must state in such
                    notice the grounds and reasons for such dispute. The Service
                    Provider shall conduct a complete and objective review of
                    such dispute and shall provide a written response to the
                    Subscriber within thirty (30) days of its receipt of such
                    written notice; Provided always that such investigation
                    shall not relief the Subscriber of any payment obligations
                    which includes and but not limited to the disputed Bill.
                  </li>
                  <li>
                    <span className="font-semibold">4.4.2.</span> Where interest
                    is relevant, the Subscriber shall pay the interest at the
                    Prescribed Rate on the amount determined (either by
                    agreement between the Subscriber and the Service Provider or
                    by any court of competent jurisdiction) to be due or payable
                    to the Service Provider which the Subscriber has withheld
                    payment of due to the dispute and pending the outcome of the
                    investigation. Should the outcome of the investigation
                    render the amount disputed due and payable by the
                    Subscriber, the interest at the Prescribed Rate shall be
                    calculated and compounded in such manner determined by the
                    Service Provider as from the date when the amount should
                    have become payable but for such dispute to the date of
                    payment thereof.
                  </li>
                </ol>
              </li>
              <li className="space-y-4">
                <span className="font-semibold">4.5.</span> A Subscriber who:
                <ol className="leading-relaxed space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> pays a Bill, and
                    subsequently chooses to dispute any amount, item, entry or
                    matter (excluding any amount, item, entry or matter relating
                    to any amount debited to the Subscriber&apos;s Account in
                    accordance with Clause) stated therein; or
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> has an amount
                    (excluding any amount debited to the Subscriber&apos;s
                    Account in accordance with Clause) deducted from Pre-Paid
                    Fees, and subsequently chooses to dispute such deduction,
                  </li>
                </ol>
                <div>
                  must give the Service Provider a written notice of such
                  dispute not later than six (6) months from the date of such
                  Bill, or deduction of Pre-Paid Fees, as applicable, providing
                  all necessary details of and reasons for the dispute and
                  supported by documentary evidence. If the Subscriber serves
                  any such written notice on the Service Provider within the six
                  (6) months period, then the Service Provider will conduct a
                  complete and objective review of such disputed amount, item,
                  entry, matter or deduction and will provide a written response
                  to the Subscriber within sixty (60) days of its receipt of
                  such written notice. Notwithstanding any provision in these
                  General Terms to the contrary, the Service Provider&apos;s
                  liability to the Subscriber in respect of a disputed deduction
                  from Pre-Paid Fees shall not in aggregate exceed the amount of
                  the Pre-Paid Fees.
                </div>
              </li>
              <li>
                <span className="font-semibold">4.6.</span> Any overpayment by
                the Subscriber with respect to any amount, item, entry or matter
                stated in the Bill shall be credited by the Service Provider
                (without interest) to the relevant Account after the Service
                Provider has completed its investigations and is satisfied as to
                the error or inaccuracy of that amount, item, entry or matter.
              </li>
              <li>
                <span className="font-semibold">4.7.</span> The Service Provider
                may render a Bill in respect of Services monthly or at such
                other intervals or time after the Services have been rendered as
                the Service Provider may consider to be appropriate or
                convenient.
              </li>
            </ol>
            <li className="font-semibold text-lg">Credit Limit</li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">5.1.</span> The Service is
                subject to credit limits which shall be allocated to the
                Subscriber pursuant to the Service. The Subscriber shall be
                responsible to ensure the use of the Service does not exceed the
                allocated credit limit and may request for a reduction or
                increase of the allocate credit limit from the Service Provider
                provided that such request for reduction or increase is deem
                appropriate by the Service Provider.
              </li>
              <li>
                <span className="font-semibold">5.2.</span> In the event the
                Subscriber exceeds the credit limit, the Subscriber agrees that
                the Service Provider shall have the option to bar or suspend the
                Service . The Service Provider shall not be liable for any loss
                or damages that the Subscriber may suffer due to any suspension
                or barring of Service should the Fees and Charges incurred by
                the Subscriber&apos;s usage exceeds the credit limit. Any
                failure by the Service Provider to suspend or bar the Service
                shall not operate as waiver of rights.
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Subscriber&apos;s Obligations
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">6.1.</span> The Subscriber
                shall:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> be responsible
                    for the use of the Equipment, Service and/or the content
                    disseminated via the Service;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> ensure at all
                    times that all electronic devices and equipment used in
                    relation to the Service are lawfully owned/used/possessed in
                    compliance with all the laws of Brunei Darussalam;
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> provide the
                    Service Provider with accurate and complete information and
                    to inform the Service Provider immediately of any changes to
                    such information, including any changes of the
                    Subscriber&apos;s address and/or contact particulars;
                  </li>
                  <li>
                    <span className="font-semibold">(d)</span> take all
                    reasonable steps to prevent spamming, fraudulent,
                    defamatory, offensive, improper, immoral and indecent
                    actions or illegal use of the Service;
                  </li>
                  <li>
                    <span className="font-semibold">(e)</span> use all
                    precautions to prevent loss, theft, cloning and/or
                    unauthorised use of the SIM card and to immediately notify
                    the Service Provider upon happening of the same;
                  </li>
                  <li>
                    <span className="font-semibold">(f)</span> not to use or
                    allow any part of the Service to be used;
                    <ol className="leading-relaxed pt-4 space-y-2">
                      <li>
                        <span className="font-semibold">(i)</span> to advertise,
                        transmit, store, post, display, or otherwise make
                        available pornographic materials and/or any form of
                        child sexual abuse material;
                      </li>
                      <li>
                        <span className="font-semibold">(ii)</span> for any
                        illegal or improper purposes;
                      </li>
                      <li>
                        <span className="font-semibold">(iii)</span> to
                        advertise, transmit, post, facilitate or solicit any
                        content, product or service that contains malware or any
                        other harmful, damaging or destructive programmes or
                        software or make them available;
                      </li>
                      <li>
                        <span className="font-semibold">(iv)</span> to make or
                        attempt any illegal or unauthorised access to any part
                        or component of the Service or to carry out or attempt
                        any activity (including preparatory work) involving
                        system penetration (i.e. port, stealth, security or
                        penetration scans or other information gathering
                        activity) on the Service Provider&apos;s servers or
                        network;
                      </li>
                      <li>
                        <span className="font-semibold">(v)</span> to disrupt or
                        undermine the security of the various networks and
                        systems that are connected to the Service or violate the
                        regulations, policies or procedures of such networks;
                      </li>
                      <li>
                        <span className="font-semibold">(vi)</span> to violate
                        any party&apos;s rights or affect other
                        Subscribers&apos; enjoyment of or access to any Service
                        or cause annoyance, harassment, irritation,
                        inconvenience or anxiety to anyone, e.g. denial of
                        service attacks, pinging and mailbombing, fraud or
                        pirating software; or
                      </li>
                      <li>
                        <span className="font-semibold">(vii)</span> to engage
                        in any activity that it is in the opinion of the Service
                        Provider to be harmful to the Subscribers, operations,
                        reputation or goodwill of the Service Provider.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <span className="font-semibold">(g)</span> not transfer the
                    Service Number and/or SIM card used in relation to the
                    Service to any other person without prior written approval
                    of the Service Provider. Provided always that all
                    outstanding Bills are fully settled and where accounts are
                    transferred prior to full settlement of the relevant Bill,
                    the Service Provider shall be at liberty to forfeit the
                    deposit and loyalty points if not redeemed prior to transfer
                    (if any) and further require new deposits to be provided by
                    the Subscriber for the new account.
                  </li>
                  <li>
                    <span className="font-semibold">(h)</span> be responsible to
                    examine any device received to ensure it has not been
                    modified, altered or tampered with, ensuring its
                    functionality and compatibility is to their satisfaction and
                    subsequently returning any devices (where applicable) in the
                    same condition thereby received under consideration of
                    reasonable &apos;swear &amp; tear&apos;
                  </li>
                  <li>
                    <span className="font-semibold">(i)</span> only apply and
                    engage the Services if they are of eighteen (18) years of
                    age or older.
                  </li>
                </ol>
              </li>
            </ol>
            <li className="font-semibold text-lg">Subscriber Request</li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">7.1.</span> The Service Provider
                shall not be obliged to provide, carry out or implement any
                Subscriber Request in the absence of any express agreement or
                confirmation by the Service Provider to do so and the Service
                Provider&apos;s acknowledgement of the Service Provider&apos;s
                receipt of any Subscriber Request shall not constitute an
                agreement or confirmation by the Service Provider to provide,
                carry out or implement the same.
              </li>
              <li>
                <span className="font-semibold">7.2.</span> Any Subscriber
                Request which the Service Provider has agreed or confirmed it
                would provide, carry out or implement shall be provided, carried
                out and implemented by the Service Provider subject to this
                General Terms and Specific Terms (if any) relating thereto and
                such other terms as the Service Provider may stipulate and
                within such time or period as the Service Provider may determine
                having regard to the circumstances and the resources available,
                notwithstanding any time or period that may have been stipulated
                by the Subscriber.
              </li>
              <li>
                <span className="font-semibold">7.3.</span> The Service Provider
                may, at its discretion, impose and charge fees and charges at
                such rate or in such amount and calculated in such manner as the
                Service Provider may determine in respect of any implementation,
                cancellation or revocation of any Subscriber Request and any
                Subscriber Request which is expressed or intended to supersede
                any earlier Subscriber Request shall constitute a cancellation
                of the earlier Subscriber Request.
              </li>
              <li>
                <span className="font-semibold">7.4.</span> If the Subscriber
                requests any deferment of the implementation of any Subscriber
                Request which the Service Provider had agreed or confirmed that
                it would provide, carry out or implement, the Service Provider
                may, at its discretion, impose a charge for such deferment at
                such rate or in such amount and calculated in such manner as the
                Service Provider may determine at that time.
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Access to Premises and Charges for Attendance and Inspection
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">8.1.</span> The Subscriber
                shall, whenever required by the Service Provider ensure that the
                Service Provider&apos;s authorised personnel be permitted to
                enter any premises occupied or controlled by the Subscriber at
                such time as may be specified by the Service Provider and to
                remain on such premises for such period as may be required:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> to carry out any
                    inspection, repair or testing of any Equipment;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> to check and
                    verify the manner in which any Service is being utilised by
                    the Subscriber and the compliance by the Subscriber with the
                    General Terms and Specific Terms in the use of any Service
                    or any Equipment;
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> to install,
                    collect, remove, maintain or replace any Equipment; and/or
                  </li>
                  <li>
                    <span className="font-semibold">(d)</span> for any other
                    purpose whatsoever.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">8.2.</span> If any authorised
                personnel or contractor of the Service Provider is required to
                visit any premises (other than the premises occupied by the
                Subscriber) to inspect, test, repair, install, remove or replace
                any Equipment and/or software used by the Subscriber in
                connection with any Service, the Service Provider shall be
                entitled to charge the Subscriber for each visit and/or for the
                work carried out by its personnel or contractor at any such
                premises for the purpose at such rate or in such amount and
                calculated in such manner as the Service Provider may determine
                at the time unless such visit is made to repair or replace any
                Equipment in discharge of any obligation by the Service Provider
                under any warranty given by the Service Provider to Subscriber
                with respect to that Equipment.
              </li>
              <li className="space-y-4">
                <span className="font-semibold">8.3.</span> In the event that:
                <ol className="leading-relaxed space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> the Subscriber
                    cancels any appointment made with the Service
                    Provider&apos;s personnel or contractor to visit any
                    premises to install, inspect, maintain or repair any
                    Equipment; or
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> the Service
                    Provider&apos;s personnel or contractor is unable at the
                    date and time specified in any such appointment to gain
                    access to the premises or to carry out such installation,
                    inspection, maintenance or repair for any reason not
                    attributable to the Service Provider or its personnel or
                    contractor,
                  </li>
                </ol>
                <div>
                  the Service Provider may, at its discretion, charge the
                  Subscriber such fee for the cancellation or the visit of the
                  Service Provider&apos;s personnel or contractor to the
                  premises on that date at such rate as may be determined by the
                  Service Provider.
                </div>
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Service, Equipment and Software
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">9.1.</span> The Subscriber shall
                be responsible and liable for obtaining and maintaining in the
                Subscriber&apos;s name and at the Subscriber&apos;s expense all
                licences, permits, consents, waivers, authorisations and
                intellectual property or other rights required for the provision
                of any Service or the installation or the use of any Equipment
                in conjunction therewith for the entire duration during which
                the Service is provided or made available to the Subscriber.
              </li>
              <li>
                <span className="font-semibold">9.2.</span> The Subscriber
                shall:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> ensure that any
                    and all electronic devices and equipment connected to or
                    used in conjunction with any Service is accordance with the
                    Law and/or compatible with the Service Provider&apos;s
                    Services and shall obtain the prior written approval of the
                    Service Provider before any electronic devices and equipment
                    is connected to any telecommunications system operated by
                    the Service Provider, or any Equipment, except where the
                    Service Provider has dispensed with the requirement for such
                    approval;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> promptly comply
                    with all notices, instructions or directions given by the
                    Service Provider in respect of the installation, use or
                    operation of the Service and all relevant Equipment;
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> where required by
                    the Service Provider, at his own expense, carry out such
                    additions, improvements, adjustments, modifications,
                    alterations or replacements to any electronic devices,
                    equipment (other than Equipment) and software which is
                    connected to any telecommunications system operated by the
                    Service Provider or, to any Equipment, as and when required
                    by the Service Provider for the purpose of maintaining
                    quality or increasing efficiency of any Service or
                    efficiently handling the volume or increased volume of
                    telecommunications traffic or for any other purpose
                    whatsoever;
                  </li>
                  <li>
                    <span className="font-semibold">(d)</span> install, use and
                    keep all Equipment in good working condition (fair wear and
                    tear excepted) in accordance with the specifications,
                    guidelines and recommendations of the manufacturer or
                    distributor thereof and the Service Provider, and shall
                    disconnect or cease to use any such Equipment at the request
                    of the Service Provider;
                  </li>
                  <li>
                    <span className="font-semibold">(e)</span> retain all
                    Equipment at all times in the custody and control of the
                    Subscriber at the premise(s) occupied by the Subscriber or
                    at such other premise(s) as the Service Provider may have
                    approved in writing;
                  </li>
                  <li>
                    <span className="font-semibold">(f)</span> provide at his
                    own expense, when required by the Service Provider, all
                    facilities and resources whatsoever necessary for the proper
                    installation, operation and maintenance of the Service and
                    all Equipment, including but not limited to, power sockets,
                    electricity, conduits, pipes and appropriate access,
                    licence, way-leave, or easement rights; and
                  </li>
                  <li>
                    <span className="font-semibold">(g)</span> ensure that all
                    electronic devices and equipment (other than Equipment) used
                    or installed by or for the Subscriber in conjunction with
                    any Service is compatible and may properly function and
                    operate with all other electronic devices and equipment used
                    or installed for the purpose.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">9.3.</span> The Subscriber shall
                not:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> use or permit the
                    use of any Service or install, connect, link or use (or
                    permit the installation, connection, linking or use) of any
                    telecommunications or broadcasting equipment in
                    contravention of any Law or any Subscriber Agreement or in
                    any manner in connection with or for the purposes of any
                    activities which would or may cause any irritation,
                    annoyance, embarrassment, harassment, disturbance or
                    nuisance of any kind whatsoever to or otherwise be
                    prejudicial to the interests of any person or which would
                    disrupt the provision or operation of any telecommunications
                    service or broadcasting service by the Service Provider;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> carry out or
                    permit to be carried out any additions, improvements,
                    adjustments, modifications, alterations or replacements to
                    any Equipment without the prior written consent of the
                    Service Provider;
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> without the prior
                    written consent of the Service Provider, use, or permit any
                    Service to be used, in any way directly or indirectly carry
                    or transmit (or facilitate the carriage or transmission) of
                    any message, data or information which does not belong to or
                    originate from the Subscriber, for the purpose of (or in
                    conjunction with) marketing, sale or provision of any
                    telecommunications service or facility to any person or
                    re-selling any Service;
                  </li>
                  <li>
                    <span className="font-semibold">(d)</span> allow or permit
                    any person to utilise the Service or any Equipment or retain
                    possession of any Equipment without the prior written
                    approval of the Service Provider; or
                  </li>
                  <li>
                    <span className="font-semibold">(e)</span> use or permit any
                    Service or any telecommunications equipment or broadcasting
                    equipment to be used in any manner or for any activity
                    whatsoever which generates or is likely to generate
                    telecommunications traffic or usage which causes or is
                    likely to cause congestion in or disruption to the provision
                    or operation of any telecommunications service by the
                    Service Provider.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">9.4.</span> Where the Fees and
                Charges imposed by the Service Provider on the Subscriber for
                the Service are based on any particular use (or use for any
                particular purpose), the Subscriber shall not utilise or permit
                the Service to be utilised for any other use or purpose without
                first notifying and obtaining the consent of the Service
                Provider thereto and the Service Provider may impose different
                Fees and Charges for such other use or purpose. In the event
                that the Subscriber fails to notify and obtain the Service
                Provider&apos;s consent to any change in the purpose for which
                the Service is used, the Service Provider shall be entitled to
                retroactively impose the appropriate Fees and Charges for such
                use after discovering the change and/or terminate the Service.
              </li>
              <li>
                <span className="font-semibold">9.5.</span> The Service Provider
                may at any time change or upgrade any telecommunications
                equipment or broadcasting equipment, system or network
                maintained or operated by the Service Provider or any Equipment
                and in such event, the Subscriber shall change, upgrade, acquire
                and/or install all such electronic devices, equipment and/or
                software that may be necessary, at his expense, in order to
                continue to enjoy or utilise any Service.
              </li>
              <li>
                <span className="font-semibold">9.6.</span> The Subscriber shall
                permit the Service Provider to upgrade or replace any Equipment
                at any time and shall, at the request of the Service Provider,
                promptly return any Equipment in exchange for any replacement or
                upgrade.
              </li>
              <li>
                <span className="font-semibold">9.7.</span> Notwithstanding any
                provision in these General Terms to the contrary, the Service
                Provider assumes no responsibility or obligation to upgrade or
                replace any Equipment (whether or not consequent to any change
                or upgrade of any system or network maintained or operated by
                the Service Provider) to ensure the continuity of any Service.
              </li>
              <li>
                <span className="font-semibold">9.8.</span> The Subscriber shall
                conduct his own investigations and enquiries to verify the
                accuracy of any information (including any number) provided by
                the Service Provider (whether or not as part of any call tracing
                service) relating to the source from which any call, signal or
                transmission (whether to any electronic devices and/or equipment
                of the Subscriber or any person) originates and shall not rely
                solely on such information to lodge any complaint or take any
                action against any person.
              </li>
              <li>
                <span className="font-semibold">9.9.</span> The Service Provider
                does not represent, warrant, guarantee or assume any
                responsibility for the quality of any Service or signals or data
                transmitted as part of any Service (including but not limited to
                telephone, facsimile, broadband and television transmissions)
                and shall not be liable for any loss or damage which may be
                caused by the loss or mutilation of any signals or data at any
                stage of the transmission, whether in progress or completed.
              </li>
              <li>
                <span className="font-semibold">9.10.</span> Where the
                Subscriber purchases any electronic devices and/or equipment
                from the Service Provider, the Service Provider shall transfer
                to the Subscriber such manufacturer&apos;s warranties as may be
                capable of transfer to the Subscriber. The Subscriber
                acknowledges and agrees that this Clause constitutes the
                Subscriber&apos;s sole and exclusive remedy and the Service
                Provider&apos;s sole and exclusive liability in respect of any
                defects, faults or failure in or of such electronic devices
                and/or equipment. All implied or statutory warranties and all
                other warranties implied by law as to merchantability, quality
                or fitness for a particular purpose, or otherwise arising from
                course of dealing or usage of trade or any other express or
                implied warranties or representations are excluded. In
                particular, the Service Provider does not warrant that any such
                equipment is fault-tolerant or is designed, manufactured or
                intended for use for medical or any other purposes for which the
                failure of the electronic devices and/or equipment purchased
                could lead to death or personal injury
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Suspension and Termination
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">10.1.</span> The Service
                Provider may suspend (indefinitely or for such period as the
                Service Provider may consider appropriate) or
                terminate(including terminate after suspension) any or all
                Service at any time by giving not less than three (3) days&apos;
                written notice thereof to the Subscriber and stating its
                reason(s) for the suspension or termination of the Services and,
                in circumstances which the Service Provider deems appropriate,
                the means by which the Subscriber can avoid such suspension or
                termination provided that nothing herein shall prejudice or
                affect any right of the Service Provider to suspend or terminate
                any Service conferred by the Specific Terms.
              </li>
              <li>
                <span className="font-semibold">10.2.</span> The Service
                Provider may suspend (indefinitely or for such period as the
                Service Provider may consider appropriate) or terminate
                (including terminate after suspending) any or all Services at
                any time after the occurrence of any of the following events,
                without giving any prior written notice thereof to the
                Subscriber:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> any failure,
                    interruption, disruption or congestion of or in any
                    telecommunications network, system or services (whether of
                    the Service Provider or any other person);
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> if, in the
                    opinion of the Service Provider:
                    <ol className="leading-relaxed pt-4 space-y-2">
                      <li>
                        <span className="font-semibold">(i)</span> the
                        Subscriber has used, attempted to use or is likely to
                        use any Service or Equipment subscribed by the in
                        contravention of any law or any Subscriber Agreement or
                        in any manner or in connection with or for the purposes
                        of any activities which would or may cause any
                        irritation, annoyance, embarrassment, harassment,
                        disturbance or nuisance of any kind whatsoever to or
                        otherwise be prejudicial to the interests of any person
                        or which would disrupt the provision or operation of any
                        telecommunications service or broadcasting service by
                        the Service Provider; or
                      </li>
                      <li>
                        <span className="font-semibold">(ii)</span> the
                        Subscriber has breached any material obligation in any
                        agreement with the Service Provider;
                      </li>
                    </ol>
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> any gift or
                    consideration of any kind was offered or given to any
                    officer, employee, agent or contractor of the Service
                    Provider as an inducement or reward in connection with the
                    provision of any Service or Equipment;
                  </li>
                  <li>
                    <span className="font-semibold">(d)</span> any action is
                    taken by any creditor of the Subscriber to recover, realise
                    or enforce any security over any assets of the Subscriber or
                    to enforce any judgment against the Subscriber;
                  </li>
                  <li>
                    <span className="font-semibold">(e)</span> in the opinion of
                    the Service Provider, the Subscriber has perpetrated a fraud
                    on the Service Provider or has conducted itself in a manner
                    which may result in perpetrating (or which, in the opinion
                    of the Service Provider, constitutes and attempt to
                    perpetrate) a fraud on the Service Provider;
                  </li>
                  <li>
                    <span className="font-semibold">(f)</span> the death or
                    mental incapacity of the Subscriber;
                  </li>
                  <li>
                    <span className="font-semibold">(g)</span> if the Service
                    Provider is unable to obtain or maintain any licence,
                    permission or easement necessary for the provision or the
                    maintenance of the Service;
                  </li>
                  <li>
                    <span className="font-semibold">(h)</span> if in the opinion
                    of any relevant regulatory authority or law enforcement
                    body, it is not in the public interest to continue providing
                    Services to the Subscriber for any reason whatsoever.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">10.3.</span> The suspension or
                termination of any Service shall be without prejudice to:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> any other right
                    which the Service Provider may have whether under this
                    General Terms or otherwise; and
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> the rights of the
                    Service Provider or the obligations of the Subscriber under
                    any Subscriber Agreement or any indemnity given by the
                    Subscriber to the Service Provider thereunder.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">10.4.</span> Where any Service
                has been suspended or deactivated (whether or not at the
                Subscriber&apos;s request), the Subscriber shall continue to pay
                those Fees and Charges in respect of:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">10.4.1.</span> that Service
                    for the period during which the Service has been suspended;
                    and,
                  </li>
                  <li>
                    <span className="font-semibold">10.4.2.</span> in the event
                    the Service is reconnected, reinstated or reactivated, in
                    respect of any and all applicable reconnection charges of
                    the Service Provider.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">10.5.</span> The Subscriber may
                terminate the Service by giving the Service Provider a minimum
                one (1) month prior written notice provided always that the
                Service may not be terminated by the Subscriber before the
                expiry of six (6) months from the date of Activation of the
                Service.
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">10.5.1.</span> Clause 10.5
                    is subject to any overriding clause within the Specific
                    Terms which would prevail, including imposition of any
                    penalties or other conditions. Wherein in such case, any
                    such clause in the Specific Terms would override this Clause
                    in the General Terms.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">10.6.</span> In the event that
                any Service is terminated:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> all sums due or
                    accruing due or payable to the Service Provider with respect
                    to that Service and/or the use of any Equipment up to the
                    date of termination and all sums due or payable to the
                    Service Provider on any and all Accounts shall upon
                    termination become immediately due and payable to the
                    Service Provider;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> the Subscriber
                    shall immediately return to the Service Provider all
                    Equipment used in relation to that Service in good working
                    condition, fair wear and tear only excepted; and/or
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> the Service
                    Provider shall be entitled to charge the Subscriber the cost
                    incurred by the Service Provider in repossessing or
                    acquiring a replacement of any Equipment which the
                    Subscriber has failed to return to the Service Provider
                    and/or of acquiring a replacement of any Equipment which is
                    returned to the Service Provider in a damaged or defective
                    condition.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">10.7.</span> Where any Service
                in respect of which the Subscriber is under an obligation to
                subscribe or use for any stipulated or minimum period is
                terminated (whether by the Service Provider or the Subscriber)
                before the expiry of that period, the Subscriber shall:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> pay the amount
                    prescribed by the Service Provider for termination or
                    cancellation of the Service before the end of that period;
                    and
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> in the absence of
                    any such amount being prescribed, the Subscriber shall
                    notwithstanding the termination of the Service pay those
                    Fees and Charges in respect of that Service which are
                    calculated or imposed with reference to any time frame or
                    interval for the remainder of that period and the aggregate
                    of all such Fees and Charges shall become immediately due
                    and payable on termination, in the absence of any Specific
                    Terms to the contrary.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">10.8.</span> The Service
                Provider may, at its absolute discretion and subject to any
                Subscriber Agreement relating thereto and any other terms which
                the Service Provider may impose, reinstate any Service which has
                been suspended or terminated subject always to the terms of the
                Subscriber Agreement thereto.
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Service Number and Intellectual Property and other Rights
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">11.1.</span> The Subscriber
                shall not acquire any right or interest in:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> any Service
                    Number notwithstanding the duration for which such Service
                    Number may have been assigned or used by the Subscriber or
                    any payment which may have been made by the Subscriber for
                    it; or
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> any and all
                    Intellectual Property and all of such property shall remain
                    at all times with the Service Provider or its licensor, as
                    the case may be.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">11.2.</span> The Service
                Provider may at any time terminate the availability of any
                Service Number or change, reassign or replace any Service Number
                without giving any reason therefor and shall not be liable for
                any loss, damage or inconvenience or otherwise, attributable to
                the change, reassignment or replacement of the Service Number.
              </li>
              <li>
                <span className="font-semibold">11.3.</span> The Subscriber
                shall not use any or permit any person to use any the
                Intellectual Property of the Service Provider except in such
                manner as may be prescribed or permitted in writing by the
                Service Provider and subject to such terms and conditions as the
                Service Provider may impose and in any case only for the purpose
                of enabling the Subscriber to utilise the Service.
              </li>
              <li>
                <span className="font-semibold">11.4.</span> The Subscriber
                acknowledges and agrees that the Service Provider does not
                warrant the nature or content of any materials which the
                Subscriber may gain access to, obtain or use as a result of or
                by means of or in the course of utilising any Service. In
                particular, the Service Provider does not warrant that such
                materials will not infringe any person&apos;s rights (including
                intellectual property rights) or contain any viruses, worms,
                Trojan horses or other malicious code.
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Subscriber&apos;s Indemnity and Liability
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">12.1.</span> The Subscriber
                shall fully indemnify and hold harmless the Service Provider at
                all times against all actions, claims, proceedings, costs
                (including legal costs incurred by the Service Provider in
                defending any such actions, claims or proceedings), liability,
                losses and damages whatsoever which may be brought or commenced
                against the Service Provider by any person and/or which the
                Service Provider may sustain, incur or suffer, as the case may
                be, arising out of or in connection with or by reason of:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> the use or
                    operation by the Subscriber or any person in any way
                    (whether with or without the authorisation and/or permission
                    of the Subscriber) of any Service subscribed by or provided
                    to the Subscriber;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> any picture,
                    material or statements howsoever published or circulated by
                    the Subscriber or any person in the course of the use of any
                    Service subscribed by or provided to the Subscriber;
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> any damage to any
                    electronic devices, equipment and/or Equipment operated or
                    used by the Subscriber or any other person (whether with or
                    without the authorisation and/or permission of the
                    Subscriber);
                  </li>
                  <li>
                    <span className="font-semibold">(d)</span> any loss of or
                    damage to or any modification or alteration of any
                    Equipment, howsoever caused or occurring at any time after
                    the same shall have been delivered or provided by the
                    Service Provider to the Subscriber or any person designated
                    by the Subscriber and before the same is returned to the
                    Service Provider; and/or
                  </li>
                  <li>
                    <span className="font-semibold">(e)</span> the enforcement
                    by the Service Provider of any rights against the Subscriber
                    under any Subscriber Agreement and/or any proceedings
                    commenced by the Service Provider for such purpose.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">12.2.</span> Where any Service
                subscribed by the Subscriber is used in any way for the purpose
                of or in conjunction with the marketing, sale or provision of
                any telecommunications or broadcasting service or facility to
                any person or for the purpose of re-selling any Service in
                breach of any of the provisions of any Subscriber Agreement or
                the law:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> the Service
                    Provider shall be deemed to have been deprived of all the
                    business and revenue generated from the sale or provision of
                    any such telecommunications or broadcasting service or
                    facility by or in conjunction with the use of the Service
                    and the re-sale of the Service, if any, by the Subscriber or
                    any such other person as a consequence;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> the Service
                    Provider shall in addition to all its other rights and
                    remedies arising therefrom be entitled to recover from the
                    Subscriber an amount representing the total amount of all
                    such business and revenue;
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> the Subscriber
                    shall at the request of the Service Provider provide the
                    Service Provider with all information and documents relating
                    to all such sales, business and revenue and procure that the
                    Service Provider and the consultants and advisers engaged by
                    the Service Provider be given access to and be allowed to
                    inspect all the books and records of each and all the
                    Subscriber to determine the value or amount of such business
                    and revenue; and
                  </li>
                  <li>
                    <span className="font-semibold">(d)</span> the Service
                    Provider may, if it so decides, elect to apply its rates and
                    charges for the Service or facilities used or sold in
                    contravention of any of the provisions of any Subscriber
                    Agreement in determining the amount recoverable by the
                    Service Provider under this Clause 12.2.
                  </li>
                </ol>
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Exclusion and Limitation of Liability of the Service Provider
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">13.1.</span> Notwithstanding any
                provision in any Subscriber Agreement to the contrary:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> the Service
                    Provider shall not be liable in any way to the Subscriber
                    whether in contract, tort (including negligence or breach of
                    statutory duty) or otherwise for any direct or indirect
                    economic or financial loss or damage (including loss of
                    revenue or profits) howsoever caused or arising, including
                    but not limited to any such loss caused or arising from any
                    breach or failure by the Service Provider to perform any of
                    its obligations under any Subscriber Agreement;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> the Service
                    Provider shall not be liable in any way to the Subscriber
                    whether in contract, tort (including negligence or breach of
                    statutory duty) or otherwise for any loss, damage or
                    liability incurred or sustained by the Subscriber caused by
                    or as a result of:
                    <ol className="leading-relaxed pt-4 space-y-2">
                      <li>
                        <span className="font-semibold">(i)</span> any failure,
                        delay, interruption to or disruption of any Service in
                        the transmission or reception of any data through any
                        Service, howsoever caused or arising;
                      </li>
                      <li>
                        <span className="font-semibold">(ii)</span> any defect
                        or deficiency in or the breakdown or failure of any
                        Equipment or system (whether or not maintained or
                        operated by the Service Provider or any other person)
                        howsoever arising;
                      </li>
                      <li>
                        <span className="font-semibold">(iii)</span> any defect,
                        deficiency or deterioration in the quality of any signal
                        or data transmitted as part of any Service;
                      </li>
                      <li>
                        <span className="font-semibold">(iv)</span> any loss,
                        corruption or deletion of any data or information
                        (whether belonging to, provided or stored by the
                        Customer or otherwise) transmitted to or stored in any
                        system, equipment or electronic devices (whether or not
                        maintained or operated by the Service Provider, the
                        Subscriber or any other person), howsoever caused or
                        arising;
                      </li>
                      <li>
                        <span className="font-semibold">(v)</span> any event the
                        occurrence of which the Service Provider is unable to
                        control or avoid by the use of reasonable diligence,
                        including but not limited to the failure, shortage or
                        interruption of electrical power or supply, riots or
                        civil commotion, strikes, lock outs or trade or labour
                        disputes or disturbances, plague, epidemic or
                        quarantine, fire, flood, drought or acts of any
                        government or sovereign, change in any Law, acts of war
                        or terrorism (whether real or perceived), inclement or
                        extreme weather conditions and acts of God or events
                        beyond the control of the Service Provider which
                        continues to persist for a period of three (3) months;
                      </li>
                      <li>
                        <span className="font-semibold">(vi)</span> the
                        disclosure and/or publication by the Service Provider of
                        any information or data relating to the Subscriber, any
                        Service Number or any Account, howsoever caused or
                        arising;
                      </li>
                      <li>
                        <span className="font-semibold">(vii)</span> the use in
                        any manner and/or for any purpose whatsoever by any
                        person at any time whatsoever and from time to time of
                        any information or data relating to the Subscriber or
                        any Account or transmitted through the use of any
                        Service subscribed by or provided to the Subscriber
                        and/or relating to the use of any such Service whether
                        by the Subscriber or any person and/or provided by the
                        Subscriber to the Service Provider; and/or
                      </li>
                      <li>
                        <span className="font-semibold">(viii)</span> any error,
                        omission or inaccuracy in any information provided by
                        the Service Provider whether to the Subscriber or any
                        person and whether in any publication or as part of or
                        in connection with any Service (including any call
                        tracing service) or Equipment or otherwise; and
                      </li>
                    </ol>
                  </li>
                  <li>
                    <span className="font-semibold">(c)</span> subject always to
                    the exemptions and exclusions set out in Clause 13.1 above,
                    the Service Provider&apos;s liability to the Subscriber
                    whether in contract, tort (including negligence or breach of
                    statutory duty) or otherwise for any and all losses, damages
                    or liabilities caused or arising from any breach, failure or
                    default of the Service Provider to perform any of its
                    obligations or duties to the Subscriber (whether arising
                    under any Subscriber Agreement or at law) with respect to
                    any Service shall not in aggregate exceed the amount equal
                    to only those Fees and Charges in respect of the Service
                    which are prescribed and imposed with reference to any time
                    frame or interval (but not usage) for the period of three
                    months immediately preceding such breach, failure or default
                    on the part of the Service Provider or, if the amount of
                    those Fees and Charges for such period is zero, the amount
                    equal to the total amount of the Fees and Charges paid by
                    the Subscriber to the Service Provider for the same period.
                  </li>
                </ol>
              </li>
            </ol>
            <li className="font-semibold text-lg">Amendment and Variation </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">14.1.</span> The Service
                Provider may amend, vary or supplement any Subscriber Agreement
                (including the General Terms, Specific Terms, Fair Use Policy
                any Fees and Charges, the Prescribed Rate and/or any other terms
                or conditions relating to any Account or Service) by giving
                seven (7)days notice thereof to the Subscriber and any such
                amendment, variation or supplement shall take effect as from the
                date specified in such notice. Any such notice given by the
                Service Provider in accordance with Clause 20, by publication in
                any newspaper circulating in Brunei Darussalam, posting on any
                internet website of the Service Provider or by otherwise making
                public such notice in any other such manner deemed appropriate
                by the Service Provider, shall constitute good and sufficient
                notice thereof to the Subscriber by the Service Provider and
                shall be deemed to have been received by the Subscriber in
                accordance with Clause 20 or on the date of such publication,
                posting or the making public of such notice, as applicable.
              </li>
            </ol>
            <li className="font-semibold text-lg">Waiver</li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">15.1.</span> No failure to
                exercise or enforce, and no delay on the part of the Service
                Provider in exercising or enforcing its rights under any this
                General Terms, Specific Term,Subscriber Agreement and Fair Use
                Policy shall operate as a waiver thereof nor shall such failure
                or delay in any way prejudice or affect the right of the Service
                Provider at any time thereafter to act strictly in accordance
                with its rights and powers under such General Terms, Specific
                Term, Subscriber Agreement and Fair Use Policy.
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Confidentiality and Non-Disclosure
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">16.1.</span> The Subscriber
                shall not use (other than for the purpose of utilising the
                Service) or disclose to any person any information relating to
                the Service Provider which is acquired from or provided by:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> the Service
                    Provider; and/or
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> any contractor of
                    the Service Provider in connection with or in the course of
                    the provision of any Service, other than information which
                    is or has become publicly available otherwise than through a
                    breach of any obligation of the Subscriber.
                  </li>
                </ol>
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Right to Collect, Use and Disclose data and information of the
              Subscriber
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">17.1.</span> The Service
                Provider, in deciding whether to approve any application of the
                Service, shall be authorised to conduct inquiry and assessment
                on the credit information of any proposed Subscriber.
              </li>
              <li>
                <span className="font-semibold">17.2.</span> The Service
                Provider shall have the right to disclose any personal and
                credit information of the Subscriber in the possession of the
                Service Provider to the Service Provider related corporations,
                corporate shareholders, third parties and/or relevant
                authorities for the provision of integrated or related services
                and marketing programmes.
              </li>
            </ol>
            <li className="font-semibold text-lg">Assignment</li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">18.1.</span> The Subscriber
                shall not assign, transfer or encumber any or all of its rights,
                interests and obligations under any Subscriber Agreement with
                respect to any Service and/or Equipment without the prior
                written consent of the Service Provider.
              </li>
              <li>
                <span className="font-semibold">18.2.</span> The Service
                Provider may assign and transfer any or all of its rights,
                interests and obligations under any Subscriber Agreement to any
                third party. Any such assignment or transfer shall take effect
                upon service on the Subscriber of a notice thereof. In the event
                that the Service Provider assigns and transfers all its rights,
                interest and obligations under any Agreement:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> all references to
                    the Service Provider in the General Terms, Specific Terms
                    and Fair Use Policy shall upon and after any such assignment
                    and transfer be construed as a reference to the assignee and
                    transferee of the Service Provider; and
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> such assignee and
                    transferee shall be entitled to enforce all rights and
                    perform all obligations of the Service Provider and to be
                    paid all sums due or accruing due from the Subscriber under
                    the Subscriber Agreement as at the date of such assignment
                    and transfer thereafter.
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">18.3.</span> The Service
                Provider may novate any or all of its rights, interests and
                obligations under any Subscriber Agreement to any third party.
                By subscribing to the Services, the Subscriber consents to the
                novation. In the event that the Service Provider novates all its
                rights, interests and obligations under any Agreement:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> all references to
                    the Service Provider in the General Terms, Specific Terms
                    and Fair Use Policy shall upon and after any such novation
                    be construed as a reference to the novatee of the Service
                    Provider.
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> such novatee
                    shall be entitled to enforce all rights and perform all
                    obligations of the Service Provider and to be paid all sums
                    due or accruing due from the Subscriber under the Subscriber
                    Agreement as at the date of such novation.
                  </li>
                </ol>
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Applicable Laws and Jurisdiction
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">19.1.</span> The Subscriber
                Agreement relating to any Service or Equipment shall be subject
                to and construed in accordance with the laws of Brunei
                Darussalam.
              </li>
              <li>
                <span className="font-semibold">19.2.</span> The Subscriber
                hereby agrees that all claims and disputes relating to or
                arising from the Subscriber Agreement, including any question
                regarding the existence, validity or termination of the
                Subscriber Agreement shall be referred to the non-exclusive
                jurisdiction of the Courts of Brunei Darussalam.
              </li>
            </ol>
            <li className="font-semibold text-lg">
              Notices and Correspondence
            </li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">20.1.</span> All notices and
                communications by the Service Provider (excluding Bills in
                relation to which Clause 4 shall apply) to the Subscriber may be
                sent to the Subscriber by delivery, post, e-mail or facsimile
                transmission or any other means deemed appropriate by the
                Service Provider address, e-mail or facsimile number of the
                Subscriber appearing in any record of the Subscriber maintained
                by the Service Provider. Any such notice, demand or
                communication addressed and sent to the shall be deemed to have
                been received by the Subscriber:
                <ol className="leading-relaxed pt-4 space-y-2">
                  <li>
                    <span className="font-semibold">(a)</span> in the case of
                    despatch by e-mail or facsimile transmission or other
                    instantaneous electronic communications, immediately upon
                    transmission by the Service Provider;
                  </li>
                  <li>
                    <span className="font-semibold">(b)</span> in the case of by
                    way of post, on the next day after it was posted by the
                    Service Provider
                  </li>
                </ol>
              </li>
              <li>
                <span className="font-semibold">20.2.</span> All notices and
                requests from the Subscriber to the Service Provider shall be in
                writing unless the Service Provider specifies to the Subscriber
                otherwise. The Service Provider shall be entitled to regard as
                ineffective and invalid any notice or request of the Subscriber
                the receipt of which by the Service Provider has not been
                confirmed by the Service Provider to the Subscriber.
              </li>
            </ol>
            <li className="font-semibold text-lg">Severability</li>
            <ol className="leading-relaxed space-y-4">
              <li>
                <span className="font-semibold">21.1.</span> Any part of this
                Agreement that is invalid, unenforceable or illegal shall be
                enforced as nearly as possible in accordance with its terms, but
                shall otherwise be deemed severed and shall not affect the
                enforceability of any other part of the Subscriber Agreement,
                which shall continue to be valid and enforceable to the fullest
                extent permitted by law.
              </li>
            </ol>
          </ol>
        </div>
        <div className="flex justify-center">
          <Button type="button" transparent onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

TermsAndConditionModal.propTypes = {
  onClose: PropTypes.instanceOf(Function).isRequired,
};

export default TermsAndConditionModal;
